import type { ToastManager } from "../Toast";
import {
  resolveAnnotationOperationErrorMessage,
  trackingPreviewFailureToastMessage,
} from "./messages";
import type {
  AnnotationOperationError,
  AnnotationStudioLocale,
  TrackingPreviewStatus,
  TrackingPreviewTargetMedia,
} from "./types";
import { useStudioErrorToast } from "./useStudioErrorToast";

export function useTrackingPreviewErrorToast({
  manager,
  status,
  targetMedia,
  error,
  locale,
  mediaContext,
}: {
  manager: ToastManager;
  status: TrackingPreviewStatus;
  targetMedia: TrackingPreviewTargetMedia | null;
  error: AnnotationOperationError | null;
  locale: AnnotationStudioLocale;
  mediaContext: string;
}): void {
  const errorMessage = resolveAnnotationOperationErrorMessage(error, locale);
  const failedTargetMedia = status === "error" ? targetMedia : null;

  useStudioErrorToast({
    manager,
    notification:
      failedTargetMedia === null
        ? null
        : {
            signature: [
              locale,
              failedTargetMedia.sequenceId,
              failedTargetMedia.streamId,
              error?.code ?? "",
              errorMessage ?? "",
              mediaContext,
            ].join("|"),
            message: trackingPreviewFailureToastMessage(locale, mediaContext, errorMessage),
          },
  });
}
